module.exports = __webpack_public_path__ + "img/kluce-byvanie.97673624.svg";